import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/happyhours/happyhours/app/[locale]/home-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/happyhours/happyhours/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
